module.exports = __webpack_public_path__ + "img/img-6-mobile.10526d4a.png";